import { render } from "./ListGraduate.vue?vue&type=template&id=4632814c&scoped=true"
import script from "./ListGraduate.vue?vue&type=script&lang=js"
export * from "./ListGraduate.vue?vue&type=script&lang=js"

import "./ListGraduate.vue?vue&type=style&index=0&id=4632814c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4632814c"]])

export default __exports__